
/* injects from baggage-loader */
require('./style.styl');

import React, {Fragment} from 'react'
import PropTypes from 'prop-types'
import Select from 'components/Select'
import DatePicker from 'components/DatePicker'
import range from 'lodash/range'
import moment from 'moment'

export default class TimePeriodSelector extends React.Component {
  static propTypes = {
    timePeriod: PropTypes.string,
    disabled: PropTypes.bool,
    onSelect: PropTypes.func,
    timeRanges: PropTypes.object,
    dynamicDateType: PropTypes.string,
    today: PropTypes.instanceOf(Date),
    short: PropTypes.bool
  }

  render() {
    const {
      timePeriod,
      disabled
    } = this.props

    return (
      <Fragment>
        <div className='time-period-selector_range'>
          <div className='time-period-selector_select-title'>Range</div>
          <Select
            disabled={disabled}
            className='time-period-selector_select'
            value={timePeriod}
            options={[
              {name: 'Day', value: 'range'},
              {name: 'Week', value: 'week'},
              {name: 'Month', value: 'month'},
              {name: 'Year', value: 'year'}
            ]}
            onSelect={this.onTimePeriodSelect}
          />
        </div>
        {this.renderCustomRange()}
      </Fragment>
    )
  }

  renderCustomRange() {
    const {timePeriod, dynamicDateType, disabled, today, timeRanges, short} = this.props

    if (!timeRanges) return null

    const {start: startRange, end: endRange} = timeRanges

    if (timePeriod === 'year') {
      const currentYear = moment(today).get('year')
      const yearsRangeMap = range => range.map(year => {
        return {name: year, value: year}
      })
      return (
        <div className='time-period-selector_custom-range'>
          <div className='time-period-selector_select-title'>Compare</div>
          <Select
            className='time-period-selector_year-select'
            disabled={disabled}
            value={moment(startRange.start).get('year')}
            options={yearsRangeMap(range(currentYear - 2, currentYear + 1))}
            onSelect={this.onStartYearSelect}
          />
          <div className='time-period-selector_select-title is-second'>with</div>
          <Select
            className='time-period-selector_year-select'
            disabled={disabled}
            value={moment(endRange.start).get('year')}
            options={yearsRangeMap(range(currentYear - 2, currentYear))}
            onSelect={this.onEndYearSelect}
          />
        </div>
      )
    } else {
      return (
        <div className='time-period-selector_custom-range'>
          <div className='time-period-selector_select-title'>Compare</div>
          <DatePicker
            short={short}
            disabled={disabled}
            startDate={moment(startRange.start).toDate()}
            endDate={moment(startRange.end).toDate()}
            today={moment(today).toDate()}
            modes={[timePeriod]}
            dynamicDateType={dynamicDateType}
            onSelect={this.onSelectStartRange}
          />
          <div className='time-period-selector_select-title is-second'>with</div>
          <DatePicker
            short={short}
            disabled={disabled}
            startDate={moment(endRange.start).toDate()}
            endDate={moment(endRange.end).toDate()}
            today={moment(today).toDate()}
            maxDate={moment(this.getMaxDate()).toDate()}
            modes={[timePeriod]}
            onSelect={this.onSelectEndRange}
          />
        </div>
      )
    }
  }

  onTimePeriodSelect = item => {
    const {onSelect, timeRanges} = this.props
    const {start, end} = timeRanges
    onSelect(item.value, start, end)
  }

  onStartYearSelect = item => {
    const year = moment([item.value])
    this.onSelectStartRange(year.clone().startOf('year'), year.clone().endOf('year'))
  }

  onEndYearSelect = item => {
    const year = moment([item.value])
    this.onSelectEndRange(year.clone().startOf('year'), year.clone().endOf('year'))
  }

  onSelectStartRange = (start, end, dynamicDateType, range) => {
    const {onSelect, timePeriod, timeRanges} = this.props
    const {end: endRange} = timeRanges
    const startRange = {start, end}

    onSelect(timePeriod, startRange, endRange, dynamicDateType)
  }

  onSelectEndRange = (start, end) => {
    const {onSelect, timePeriod, timeRanges} = this.props
    const {start: startRange} = timeRanges
    const endRange = {start, end}

    onSelect(timePeriod, startRange, endRange)
  }

  getMaxDate() {
    const {today, timePeriod} = this.props

    switch (timePeriod) {
      case 'week':
        return moment(today).subtract(1, 'week').startOf('isoWeek')
      case 'month':
        return moment(today).startOf('month')
    }
  }
}



// WEBPACK FOOTER //
// ./client/components/TimePeriodSelector/index.js